import { ReactUtils } from '@shared/ui-react/ReactUtils';
import { Dialog } from '@shared/ui-react/Dialog';
import * as React from 'react';
import { observer } from 'mobx-react';
import { Ajax2 } from '@shared/Ajax';
import { makeObservable, observable } from 'mobx';
import { Button } from '@shared/ui-react/Button';
import { Notify } from '@shared/ui-native/Notify';
import { MaterialsStore } from '@pages/trucks/store/MaterialsStore';

export const DeleteMaterialDialog = {
    open: (materialsStore: MaterialsStore, materialId: number, areasContainingMaterial: string[], onSuccess: Function) => {
        const targetEl = document.getElementById('react-portal-root');
        ReactUtils.safeRender(
            <Dialog onClose={DeleteMaterialDialog.close} title={__('trucks.materials.delete_material')}>
                <DeleteMaterialComponent materialsStore={materialsStore} materialId={materialId} areasContainingMaterial={areasContainingMaterial} onSuccess={onSuccess} />
            </Dialog>,
            targetEl
        );
    },

    close: () => {
        ReactUtils.safeUnmountComponentAtNode(document.getElementById('react-portal-root'));
    },
};

@observer
class DeleteMaterialComponent extends React.Component<
    {
        materialsStore: MaterialsStore;
        materialId: number;
        areasContainingMaterial: string[];
        onSuccess: Function;
    },
    {}
> {
    @observable isRunning = false;
    @observable destinationMaterialId = -1;
    @observable isMaterialInTrips: boolean = false;

    constructor(props: any) {
        super(props);
        makeObservable(this);
    }

    componentDidMount() {
        this.destinationMaterialId = this.props.materialsStore.items.find(m => m.id !== this.props.materialId).id;

        this.props.materialsStore
            .isMaterialInTrip(this.props.materialId)
            .done(resp => (this.isMaterialInTrips = resp.isUsed))
            .fail(Notify.error);
    }

    render() {
        const source = this.props.materialsStore.items.find(m => m.id === this.props.materialId);
        const materials = this.props.materialsStore.items.filter(m => m.id !== this.props.materialId);

        if (!source) return null;

        return (
            <>
                <div className='padded' style={{ width: 400 }}>
                    {this.props.areasContainingMaterial.length > 0 && (
                        <div style={{ marginBottom: '25px' }}>
                            {__('trucks.materials.deleting_allowed_material_explain')}: <b>{this.props.areasContainingMaterial.join(', ')}</b>
                        </div>
                    )}
                    {this.isMaterialInTrips ? (
                        <>
                            <div>{__('trucks.materials.marge_and_delete_explain', source.material)}:</div>
                            <select
                                value={this.destinationMaterialId}
                                onChange={e => (this.destinationMaterialId = parseInt(e.currentTarget.value))}
                                style={{ fontSize: 15, padding: '5px 10px', width: '100%', height: 'auto', marginTop: 20 }}
                            >
                                {materials.map(m => (
                                    <option key={m.id} value={m.id}>
                                        {m.material}
                                    </option>
                                ))}
                            </select>
                        </>
                    ) : (
                        <div>{__('trucks.materials.delete_material_unassigned', source.material)}</div>
                    )}
                </div>

                <footer className='infrakit-dialog__footer' style={{ justifyContent: 'space-between' }}>
                    <Button onClick={DeleteMaterialDialog.close} className='ik-button-secondary--subtle'>
                        {__('general.close')}
                    </Button>
                    <Button onClick={this.isMaterialInTrips ? this.mergeAndDelete : this.deleteMaterial} loading={this.isRunning} className='btn-danger'>
                        {__(this.isMaterialInTrips ? 'trucks.materials.marge' : 'general.delete')}
                    </Button>
                </footer>
            </>
        );
    }

    mergeAndDelete = () => {
        this.isRunning = true;
        Ajax2({
            url: `${kuura.getContextPath()}/material/${this.destinationMaterialId}/merge?projectId=` + kuura.getProjectId(),
            method: 'POST',
            contentType: 'json',
            data: {
                materialIds: String(this.props.materialId),
            },
        })
            .then(() => {
                this.props.onSuccess();
                Notify.success();
                DeleteMaterialDialog.close();
            })
            .catch(() => {
                Notify.error();
            })
            .finally(() => {
                this.isRunning = false;
            });
    };

    deleteMaterial = () => {
        this.isRunning = true;
        Ajax2({
            url: `${kuura.getContextPath()}/delete_project_material.json`,
            method: 'DELETE',
            contentType: 'json',
            data: {
                projectId: kuura.getProjectId(),
                materialId: this.props.materialId,
            },
        })
            .then(() => {
                this.props.onSuccess();
                Notify.success();
                DeleteMaterialDialog.close();
            })
            .catch(() => {
                Notify.error();
            })
            .finally(() => {
                this.isRunning = false;
            });
    };
}
